var path = 'app/scripts/modules/amazon/src/serverGroup/details/scalingPolicy/popover/scalingPolicyDetails.popover.html';
var html = "<aws-scaling-policy-popover policy=\"$ctrl.policy\" server-group=\"$ctrl.serverGroup\"></aws-scaling-policy-popover>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;